import React from "react"
import { Message, Messages } from "../Common/Messages"
import Parsing from "../Common/Parsing"
import AWS from 'aws-sdk'
import { useNavigate } from "react-router-dom"
import './Upload.css'
import { Header } from "../Common/Header"

export function Upload(): JSX.Element {

	const bucketName = 'com.timjeanes.wideopen'
	const bucketRegion = 'eu-west-2'
	const identityPoolId = 'eu-west-2:ac0b6b66-5b5e-4d6d-9e66-e5a87f1858d8'

	const [file, setFile] = React.useState<File | null>(null)
	const [messages, setMessages] = React.useState<Message[]>([])
	const [s3, setS3] = React.useState<AWS.S3 | null>(null)

	const navigate = useNavigate()

	React.useEffect(() => {

		try {

			// Initialize: establish S3 connection

			AWS.config.update({
				region: bucketRegion,
				credentials: new AWS.CognitoIdentityCredentials({
					IdentityPoolId: identityPoolId,
				}),
			})

			const s3 = new AWS.S3({
				apiVersion: "2015-12-08",
				params: { Bucket: bucketName },
			})

			setS3(s3)

		} catch (error) {
			setMessages([{
				text: `Unable to establish upload connection: ${error}`,
				type: 'error',
			}])
		}

	}, [])

	React.useEffect(() => {
		if (!file) {
			return
		}

		const reader = new FileReader()
		reader.onload = (e) => {
			const data = e?.target?.result
			if (!file || !data || typeof data !== 'string') {
				setMessages([{
					text: 'Unable to read file',
					type: 'error',
				}])
				return
			}

			try {

				const results = Parsing.processData(data)

				if (results.plays.length === 0) {
					throw new Error('File contains no valid plays')
				}

				setMessages([{
					text: `Parsed ${results.plays.length} plays`,
					type: 'info',
				}, {
					text: 'Uploading...',
					type: 'info',
				}])

				const upload = new AWS.S3.ManagedUpload({
					params: {
						Bucket: bucketName,
						Key: 'bgstats.json',
						Body: file,
					}
				})

				upload.promise()
					.then((_data) => {
						const now = new Date()
						new AWS.S3().copyObject({
							Bucket: bucketName,
							CopySource: encodeURI(`/${bucketName}/bgstats.json`),
							Key: `bgstats_${now.getFullYear()}-${now.getMonth()}-${now.getDate()}.json`,
						}, (err, _data) => {
							if (err) {
								setMessages([{
									text: 'Failed to back up',
									type: 'warning',
								}])
							}
						})

						setMessages([{
							text: 'New file uploaded',
							type: 'success',
						}])

						setTimeout(() => {
							navigate('/')
						}, 1000)
					})

			} catch (error) {
				setMessages([{
					text: `${error}`,
					type: 'error',
				}])
				return
			}
		}

		reader.readAsText(file!)

	}, [file, navigate])

	function fileChanged(e: React.ChangeEvent<HTMLInputElement>): void {
		if (!e?.target?.files?.length) {
			return
		}

		setMessages([{
			text: 'Checking file',
			type: 'info',
		}])

		setFile(e.target.files[0])

	}

	return (
		<React.Fragment>
			<Header>
				<Messages messages={ messages } />
			</Header>

			<div className="uploader">
				{ s3 &&
					<React.Fragment>
						<h2>Upload</h2>

						<label htmlFor="upload" className="upload-button">Upload file...</label>
						<input type="file" id="upload" name="upload" onChange={ (e) => fileChanged(e) } />
					</React.Fragment>
				}

				<h2>Download</h2>
				<a href="https://s3.eu-west-2.amazonaws.com/com.timjeanes.wideopen/bgstats.json">Download</a>
			</div>
		</React.Fragment>
	)
}
